export const DISABLED_LOADING_INTERCEPTOR = "Disabled-Loading-Interceptor";
export const DISABLED_NOTIFY_MESSAGE = "Disabled-Notify-Message";
